'use strict';

$(document).ready(function () {
    productTileSlickFbt();
    refreshImg();
    push_product_list_metrics();
    showProductsPreviousErrors();
});